import axios from "axios";
export default class DictionaryClass {
  a_Chapter = [];
  async p_getChapter() {
    let p_Chapter = await axios({
      method: "get",
      url: process.env.API_HOST + "/operation/dictionaryType/queryList",
      params: {
        pageSize: 9999
      }
    });
    let a_Chapter = p_Chapter.data.data.list || [];
    this.a_Chapter = a_Chapter.map(({ id, dicKey }) => ({ id, dicKey }));
    return this.a_Chapter;
  }
  async p_getchapter(s_dicKey) {
    let a_Chapter = this.a_Chapter || await this.p_getChapter();
    let temp = a_Chapter.find(it => it.dicKey == s_dicKey)
    if(temp) {
      return axios({
        method: "get",
        url: process.env.API_HOST + "operation/dictionaryType/queryById",
        params: {
          id: temp.id
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/public/DictionaryClass/index.js